<template>
  <v-text-field
    :clearable="canClear"
    :label="label"
    :rules="rules"
    :value="displayValue(value)"
    @input="v=>emit(v)"
    slot="activator"
    v-bind="$attrs"
  ></v-text-field>
</template>
<script>
export default {
  props: ['value', 'preRules', 'nextRules', 'required', 'label'],
  computed: {
    canClear() {
      if (this.$attrs.clearable === undefined) return true
      return this.$attrs.clearable
    },
    rules() {
      return (this.preRules || [])
        .concat(this.required ? [v => !!v || this.label + ' is required'] : [])
        .concat([
          v =>
            this.isNull(v) ||
           /^((?!0000)[0-9]{4}((0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-8])|(0[13-9]|1[0-2])(29|30)|(0[13578]|1[02])31)|([0-9]{2}(0[48]|[2468][048]|[13579][26])|(0[48]|[2468][048]|[13579][26])00)0229)$/.test(
              v
            ) ||
            '日付形式が正しくありません'
        ])
        .concat(this.nextRules || [])
    }
  },
  methods: {
    isNull(value) {
      return value === null || value === undefined || value === ''
    },
    displayValue(value) {
      if (value == null) {
        return
      }
      return value.replace(/-/g, '')
    },
    emit(v) {
      this.$emit(
        'input',
        v ? v.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1-$2-$3') : null
      )
    }
  }
}
</script>
